import { createDarkTheme } from 'baseui'

const DarkTheme = createDarkTheme({}, {})
export default DarkTheme
